import type { MutableRefObject, Ref, RefCallback } from 'react'

export function mergeRefs<T>(...refs: Array<Ref<T> | undefined>): RefCallback<T> {
  return (node: T | null) => {
    refs.forEach((r) => {
      if (!r) return
      if (typeof r === 'function') (r as (x: T | null) => void)(node)
      else (r as MutableRefObject<T | null>).current = node
    })
  }
}
